import getCsrfToken from '../../lib/csrfToken';
import { retrieveSizeLimitUrl } from '../../modules/Viewer/urls';

async function retrieveSizeLimit() {
  const urlPath = retrieveSizeLimitUrl();
  const path = '/' + urlPath;

  const formData = new FormData();

  const headers: HeadersInit = new Headers();
  const token = getCsrfToken();
  if (token !== undefined) {
    headers.set('X-CSRFToken', token);
  }

  const resp = await fetch(path, {
    method: 'POST',
    headers: headers,
    body: formData
  });

  const json = await resp.json();
  return json;
}

export default retrieveSizeLimit;